import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { Box } from '@mui/material';
import { useContainerSize } from '../../hooks/useContainerSize';

function buildGaugeOption(type, tagprops, liveData, theme) {
  const isDark = theme === 'dark';
  const tagprop = tagprops?.[0];
  const match = tagprop && liveData.find((d) => String(d.TagId) === String(tagprop.tagId));
  const value = parseFloat(match?.value) || 0;
  const name = tagprop?.alias || tagprop?.tagId || '—';
  const unit = tagprop?.unit || '';
  const min = tagprop?.min != null ? Number(tagprop.min) : 0;
  const max = tagprop?.max != null ? Number(tagprop.max) : 100;

  const isLinear = type === 'Linear Gauge';
  const isSemi = type === 'Semi Circular Gauge';

  return {
    series: [{
      type: 'gauge',
      min,
      max,
      startAngle: isSemi ? 180 : 225,
      endAngle: isSemi ? 0 : -45,
      pointer: { show: !isLinear },
      progress: { show: isLinear, width: 18 },
      axisLine: { lineStyle: { width: isLinear ? 18 : 10 } },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: { show: false },
      detail: {
        valueAnimation: true,
        formatter: unit ? `{value} ${unit}` : '{value}',
        color: isDark ? '#fff' : '#333',
        fontSize: 14,
        fontWeight: 700,
      },
      data: [{ value, name }],
      title: { color: isDark ? '#ccc' : '#555', fontSize: 12 },
    }],
    backgroundColor: 'transparent',
  };
}

function GeneralGaugeWidget({ widget, data, theme }) {
  const liveData = Array.isArray(data) ? data : [];
  const tagprops = widget?.props?.extended?.tagprops || [];
  const option = useMemo(
    () => buildGaugeOption(widget.type, tagprops, liveData, theme),
    [widget.type, tagprops, liveData, theme]
  );
  const { ref, width: cw, height: ch } = useContainerSize(80, 80);
  const h = Math.max(56, ch);
  const w = Math.max(56, cw);

  return (
    <Box ref={ref} sx={{ flex: 1, minHeight: 0, width: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {cw > 0 && ch > 0 ? (
        <ReactECharts option={option} style={{ width: w, height: h }} opts={{ renderer: 'canvas' }} />
      ) : null}
    </Box>
  );
}

export default React.memo(GeneralGaugeWidget);
